import api from '@/api';

const store = {
  state: {
    dataModifierItem: [],
    pagingModifierItem: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingModifierItem: {
      byField: '',
      isDesc: false
    },
    filteringModifierItem: {
      outletCode: null,
      modifierGroupCode: null,
      modifierItemCode: null,
      sequence: null,
      isTaxable: null,
      isActive: null,
      isCD: null
    }
  },

  mutations: {
    SET_MODIFIERITEM: (state, payload) => {
      state.dataModifierItem = payload;
    },
    SET_PAGING_PAGE_MODIFIERITEM: (state, payload) => {
      state.pagingModifierItem.page = payload;
    },
    SET_PAGING_TOTAL_MODIFIERITEM: (state, payload) => {
      state.pagingModifierItem.total = payload;
    },
    SET_SORTING_MODIFIERITEM: (state, payload) => {
      state.sortingModifierItem = payload;
    },
    SET_FILTERING_MODIFIERITEM: (state, payload) => {
      state.filteringModifierItem = payload;
    }
  },

  getters: {
    SortingModifierItem: state => state.sortingModifierItem,
    FilteringModifierItem: state => state.filteringModifierItem,
    PagingModifierItem: state => state.pagingModifierItem,
    GetAllModifierItem: state => state.dataModifierItem,
    GetOneModifierItem: state => id =>
      state.dataModifierItem.find(
        dataModifierItem => dataModifierItem.id === id
      )
  },

  actions: {
    async UpdateSortingModifierItem({ commit, dispatch }, payload) {
      commit('SET_SORTING_MODIFIERITEM', {
        byField: payload.byField,
        isDesc: payload.isDesc
      });
      dispatch('GetAllModifierItem');
    },

    async UpdateFilteringModifierItem({ commit, dispatch }, isResetField) {
      if (isResetField) {
        let emptyFilter = {
          cond: null,
          code: null,
          description: null
        };
        commit('SET_FILTERING_MODIFIERITEM', emptyFilter);
      }
      commit('SET_PAGING_PAGE_MODIFIERITEM', 1);
      dispatch('GetAllModifierItem');
    },

    async GetAllModifierItem({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true);
        const result = await api.GetAllModifierItem(
          state.pagingModifierItem,
          state.sortingModifierItem,
          state.filteringModifierItem
        );
        commit('SET_IS_FETCHING_DATA', false);
        commit('SET_PAGING_TOTAL_MODIFIERITEM', result.headers['data-length']);
        commit('SET_MODIFIERITEM', result.data.data);
        return result.data;
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false);
        throw e;
      }
    },

    async CreateModifierItem({ dispatch }, payload) {
      try {
        const { data } = await api.CreateModifierItem(payload);
        dispatch('GetAllModifierItem');
        return data;
      } catch (e) {
        return e.response;
      }
    },

    async UpdateModifierItem({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateModifierItem(payload.id, payload);
        dispatch('GetAllModifierItem');
        return data;
      } catch (e) {
        return e.response;
      }
    },

    async DeleteModifierItem({ dispatch }, id) {
      try {
        const { data } = await api.DeleteModifierItem(id);
        dispatch('GetAllModifierItem');
        return data;
      } catch (e) {
        throw e;
      }
    }
  }
};

export default store;
